<template>
  <div class="flex flex-col">
    <div class="flex flex-col justify-center w-full gap-4 md:w-auto md:flex-row-reverse md:justify-between">
      <button
        @click="back"
        v-if="showBack"
        class="inline-block py-1 text-sm text-center bg-white border rounded md:px-12 shadow-sc-button"
      >
        {{ $t('message.onboarding.back') }}
      </button>
      <button
        @click="next"
        v-if="showNext"
        :disabled="!isFormValid"
        class="order-first inline-block w-full px-12 py-2 text-sm leading-5 text-center text-white rounded bg-sc-blue"
        :class="{ 'opacity-25 cursor-not-allowed': !isFormValid }"
      >
        {{ $t('message.onboarding.continue') }}
      </button>
    </div>
    <button
      @click="next"
      v-if="showSkip"
      class="inline-block px-12 py-2 mt-2 text-sm text-center bg-white border rounded md:px-12 shadow-sc-button"
    >
      {{ skipButtonText }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    isFormValid: {
      type: Boolean,
      required: true,
    },
    showBack: {
      type: Boolean,
      required: false,
      default: true,
    },
    showNext: {
      type: Boolean,
      required: false,
      default: true,
    },
    showSkip: {
      type: Boolean,
      required: false,
      default: false,
    },
    skipButtonText: {
      type: String,
      required: false,
      default: 'Saltar',
    },
  },
  methods: {
    next() {
      this.$emit('next');
    },
    back() {
      this.$emit('back');
    },
  },
};
</script>
